// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5c5a56b3","977":"59ccdefd"}[chunkId] + ".chunk.js";
};